import React, { useState } from 'react';
import { TextField, ToggleButton, ToggleButtonGroup, IconButton, Grid } from '@mui/material';
import { AddCircleSharp, CloseOutlined } from '@mui/icons-material';

const FieldTypeSelector = ({ value, onChange, field, setNewField }) => {
  const [newOption, setNewOption] = useState('');
  const fieldTypes = ['text', 'number', 'date', 'select'];

  const fieldTypeTranslations = {
    text: 'Texto',
    number: 'Número',
    date: 'Data',
    select: 'Seleção',
  };

  const handleTypeChange = (event, newType) => {
    if (newType !== null) {
      setNewField({ ...field, type: newType, options: newType !== 'select' ? [] : field.options });
    }
  };

  const handleAddOption = () => {
    const updatedOptions = [...field.options, newOption];
    setNewField({ ...field, options: updatedOptions });
    setNewOption('');
  };

  const handleEditOption = (value, index) => {
    const updatedOptions = [...field.options];
    updatedOptions[index] = value;
    setNewField({ ...field, options: updatedOptions });
  };

  const handleRemoveOption = (index) => {
    const updatedOptions = field.options.filter((_, i) => i !== index);
    setNewField({ ...field, options: updatedOptions });
  };

  return (
    <Grid>
      <ToggleButtonGroup
        value={field.type}
        exclusive
        onChange={handleTypeChange}
        aria-label="Tipo do Campo"
      >
        {fieldTypes.map((type) => (
          <ToggleButton key={type} value={type} aria-label={type}>
            {fieldTypeTranslations[type]}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {field.type === 'select' && (
        <>
          <TextField
            label="Adicionar campo de opção"
            value={newOption}
            onChange={(e) => setNewOption(e.target.value)}
            fullWidth
          />
          <IconButton onClick={handleAddOption} color="primary"><AddCircleSharp /></IconButton>
          {field.options.map((option, index) => (
            <Grid container spacing={1} alignItems="center" key={index}>
              <Grid item xs>
                <TextField
                  fullWidth
                  value={option}
                  onChange={(e) => handleEditOption(e.target.value, index)}
                />
              </Grid>
              <Grid item>
                <IconButton onClick={() => handleRemoveOption(index)}>
                  <CloseOutlined />
                </IconButton>
              </Grid>
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
};

export default FieldTypeSelector;
